module.exports = __webpack_public_path__ + "img/2.3_Associate-Investigators_4_Doyle.0e53f50cc61f58857b190235b41cce9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.3_Associate-Investigators_4_Doyle.png
// module id = 760
// module chunks = 0